import intersection from 'lodash/intersection'

export const APPLICATION_MAP = {
  'cn=Portal,ou=applications,dc=mandiant,dc=com': 'MD_PORTAL',
  'cn=SalesPortal,ou=applications,dc=mandiant,dc=com': 'SALES_PORTAL',
  'cn=CompromiseReportingService,ou=applications,dc=mandiant,dc=com': 'COMPROMISE_REPORTING_SERVICE',
  'cn=FIIP,ou=applications,dc=mandiant,dc=com': 'FIIP',
  'cn=Nautilus,ou=applications,dc=mandiant,dc=com': 'NAUTILUS'
}

export const genHasSsoApplications = user => {
  const userSsoApplications = [user?.ssoApplications]
    .flat()
    .map(app => APPLICATION_MAP[app])
    .filter(Boolean)

  return (ssoApps, options = {}) => {
    if (!userSsoApplications.length) {
      return false
    }

    ssoApps = [ssoApps].flat()

    const commonCount = intersection(ssoApps, userSsoApplications).length

    return options.all
      ? commonCount === ssoApps.length
      : !!commonCount
  }
}
